<script setup lang="ts">
import { computed, type PropType } from "vue";

const props = defineProps({
  sessionNames: {
    type: Array as PropType<string[]>,
    default: [],
  },
  showActiveMsg: {
    type: Boolean,
    default: true,
  },
  layout: {
    type: String,
    default: "row",
  },
});

const sessionNames = computed<string>(() => {
  if (props.sessionNames.length === 0) return props.sessionNames.join(", ");
  return "";
});

const startingMsg = "Downloading the mobile app is the next step in completing your onboarding process";
const downloadMsg =
  ". Please go ahead and download it now to access and complete the necessary steps for your program.";

const insertPrefix = computed<string>(() => {
  if (props.showActiveMsg) {
    switch (props.sessionNames.length) {
      case 0:
        return "";
      case 1:
        return " for the ";
      default:
        return " for your upcoming programs"; // more than 1
    }
  }
  return " for your upcoming programs";
});
const insertPostfix = computed<string>(() => {
  if (props.showActiveMsg) {
    switch (props.sessionNames.length) {
      case 0:
        return "";
      case 1:
        return " program";
      default:
        return ""; // more than 1
    }
  }
  return "";
});
const flexDirection = computed<string>(() => (props.layout === "row" ? "flex-row" : "flex-col"));
</script>
<template>
  <div
    data-testid="mobile-app-banner"
    :class="[
      'flex md:flex-row items-center justify-between bg-[#EBF1FA] border border-blue-200 rounded-xl px-4 py-2 gap-4',
      flexDirection,
    ]"
  >
    <div class="flex flex-col gap-y-2">
      <h2 class="font-montserrat font-bold text-base text-[#334155] text-left">Next Up!</h2>
      <p class="font-montserrat font-medium text-sm text-university-primary text-left">
        {{ startingMsg }}{{ insertPrefix }}<span class="font-bold">{{ sessionNames }}</span
        >{{ insertPostfix }}{{ downloadMsg }}
      </p>
      <div v-if="layout === 'col'" class="flex justify-center">
        <img src="/images/mobile-app/qr-code.png" alt="QR code" class="h-19 w-18 object-contain" />
      </div>
    </div>
    <div v-if="layout === 'row'" class="flex justify-center">
        <img src="/images/mobile-app/go_to_mobile_qr_code.svg" alt="QR code" class="h-19 w-18 object-contain" />
      </div>
  </div>
</template>
